export default `
<section class="second">
<img src="++{{section18Image}}">
</section>
`